<template>
  <div class="swapDetail">
    <div class="van-dialog__header">
      <div class="text">{{ $t('lang.swap27') }}</div>
      <div class="cancel"
           @click="handleClose"></div>
    </div>
    <div class="btContent">
      <div class="content">
        <div class="tokenInfo">
          <div class="leftItem">
            <img class="tokenImg"
                 :src="fromCur.logoUrl"
                 alt="" />
            <!-- <div class="input">{{ swapDetail.fromInput }}</div> -->
          </div>
          <div class="symbol">{{ fromCur.symbol }}</div>
        </div>
        <img class="down"
             src="@/assets/img/trade.png"
             alt="" />
        <div class="tokenInfo">
          <div class="leftItem">
            <img class="tokenImg"
                 :src="toCur.logoUrl"
                 alt="" />
            <!-- <div class="input">{{ swapDetail.toInput }}</div> -->
          </div>
          <div class="symbol">{{ toCur.symbol }}</div>
        </div>
      </div>

      <!-- <div class="tip"
           v-if="swapDetail.inputSource === 'from'">
        {{ $t('lang.swap28', { inputOutMin: swapDetail.inputOutMin, symbol: toCur.symbol }) }}
      </div>
      <div class="tip"
           v-else>{{ $t('lang.swap29', { inputInMax: swapDetail.inputInMax, symbol: fromCur.symbol }) }}</div> -->

      <!-- <div class="wrap">
        <div class="wrapItem"
             @click="changePriceDirection">
          <div>{{ $t('lang.swap7') }}</div>
          <div class="priceItem">
            <div v-if="priceDirection">1{{ toCur.symbol }} = {{ swapDetail.price }} {{ fromCur.symbol }}</div>
            <div v-else>1{{ fromCur.symbol }} = {{ opppsitePrice }} {{ toCur.symbol }}</div>
            <van-image class="opppsite"
                       :src="require('@/assets/img/opposite.png')" />
          </div>
        </div>
        <div class="wrapItem"
             v-if="swapDetail.inputSource === 'from'">
          <div>{{ $t('lang.swap30') }}</div>
          <div>{{ swapDetail.inputOutMin }} {{ toCur.symbol }}</div>
        </div>
        <div class="wrapItem"
             v-else>
          <div>{{ $t('lang.swap31') }}</div>
          <div>{{ swapDetail.inputInMax }} {{ fromCur.symbol }}</div>
        </div>
        <div class="wrapItem">
          <div>流动性供应商费用</div>
          <div>{{ swapDetail.fee }} {{ fromCur.symbol }}</div>
        </div> 
    </div> -->
      <div class="iconSet">
        <span class="iconSet_text">{{ $t('lang.swap8') }}</span>
        <span>{{ slippage }}%</span>
      </div>
      <div class="slipWrap">
        <span class="slipWrap_text">{{ $t('lang.swap91') }}</span>
        <span v-if="portion <= 0.01">{{less}} 0.01%</span>
        <vspan v-if="portion > 0.01 && portion <= 1">{{portion.toFixed(2)}}%</vspan>
        <span v-if="portion > 1 && portion <= 2">{{portion.toFixed(2)}}%</span>
        <span v-if="portion > 2 && portion <= 5">{{portion.toFixed(2)}}%</span>
        <span v-if=" portion > 5">{{portion.toFixed(2)}}%</span>
      </div>
      <van-button type="primary"
                  class="confirmBtn"
                  @click="handleConfirm">{{ $t('lang.swap27') }}</van-button>
    </div>
  </div>
</template>

<script>
import { accDiv, significantDigits } from '@/utils/format.js';
import { mapState } from 'vuex';
import { toFixed, } from '@/utils/format.js';
export default {
  name: 'swapDetail',
  props: ['fromCur', 'toCur', 'swapDetail', 'portion'],
  data () {
    return {
      priceDirection: true,
      opppsitePrice: '',
      less: '<',

    };
  },
  mounted () { },
  methods: {
    handleConfirm () {
      this.$emit('listenConfirm');
    },
    handleClose () {
      this.$emit('listenClose');
    },
    changePriceDirection () {
      this.priceDirection = !this.priceDirection;
      this.opppsitePrice = significantDigits(accDiv(1, this.swapDetail.price));
    },
    significantDigits,
  },
  computed: {
    ...mapState(['slippage',]),
  }
};
</script>

<style lang="less" scoped>
.swapDetail {
  width: 350px;

  color: #ffffff;
  background: #171717;
  .van-dialog__header {
    width: 100%;
    text-align: center;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    font-weight: bold;
    font-size: 20px;

    color: #ffffff;
    .cancel {
      width: 26px;
      height: 26px;
      background-image: url('~@/assets/img/cancel.png');
      background-size: contain;
      background-repeat: no-repeat;
      cursor: pointer;
    }
  }
  .btContent {
    width: 100%;

    padding: 0 16px;
  }
  .content {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .iconSet {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    font-weight: bold;
    color: #ffffff;
    .iconSet_text {
      color: #878995;
    }
  }
  .slipWrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    font-weight: bold;
    color: #65fce4;
    margin: 12px 0 20px;
    .slipWrap_text {
      color: #878995;
    }
  }
  .down {
    height: 30px;
    width: 30px;
  }
  .tokenInfo {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 0;
    .leftItem {
      display: flex;
      align-items: center;
      margin-right: 10px;
      .input {
        margin-left: 5px;
      }
      .tokenImg {
        height: 30px;
        width: 30px;
        border-radius: 50%;
      }
      .symbol {
        font-size: 16px;
      }
    }
  }
  .tip {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #a399d9;
    margin-top: 20px;
  }
  .wrap {
    border: 1px solid #f2f2f2;
    padding: 4px 16px;
    font-size: 14px;
    margin-top: 20px;
    .wrapItem {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 4px 0;
      .priceItem {
        display: flex;
        align-items: center;
        .opppsite {
          height: 20px;
          width: 20px;
          margin-left: 4px;
        }
      }
    }
  }
  .confirmBtn {
    width: 100%;
    margin: 0 0 22px;
    font-size: 14px;
    font-weight: bold;
    color: #000000;
    background: linear-gradient(321deg, #fdde34 0%, #65fce4 100%);
    border: 0;
  }
}
</style>
